import React from "react";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Form, Card, Col, InputNumber } from "antd";

//PROJECT IMPORTS
import appLabel from "../../../../../config/appLabel";
import { BOM } from "../../../../../services/definedMethod";

const { Text } = Typography;

export default function TermsForm({ redeDetail }) {
  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Default Deposit Amount</Text>}>
              <InputNumber
                style={{ width: "100%" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
                placeholder="Not set"
                className="of-bold-disable-input"
                disabled
                value={redeDetail.depositAmount ?? null}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Minimum Deposit Amount</Text>}>
              <InputNumber
                style={{ width: "100%" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
                placeholder="Not set"
                className="of-bold-disable-input"
                disabled
                value={redeDetail.minDepositAmount ?? null}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Maximum Deposit Amount</Text>}
              rules={[{ required: true, message: "Required Field" }]}
            >
              <InputNumber
                style={{ width: "100%" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
                placeholder="Not set"
                className="of-bold-disable-input"
                disabled
                value={redeDetail.maxDepositAmount ?? null}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.interestCompoundingPeriod}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.interestCompoundingPeriodType?.value}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.interestPostingPeriod}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.interestPostingPeriodType?.value}
              ></Input>
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.interestCalculatedUsing}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.interestCalculationType?.value}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.daysInYear}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.interestCalculationDaysInYearType?.value}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
}
